/**
 * BrandLogo — the official BHABY HEALTH CONNECT mark.
 *
 * Single source of truth for platform branding. Uses the official logo asset
 * (client/public/logo.png) at its natural aspect ratio (object-fit: contain —
 * never stretched or cropped). Functional Lucide icons elsewhere in the app
 * are NOT branding and must not be replaced by this component.
 */
import React from 'react';

interface BrandLogoProps {
  /** Rendered size class for the logo box; keep the aspect ratio intact. */
  className?: string;
  /** Alt text — pass empty string only when adjacent text already names the brand. */
  alt?: string;
}

const BrandLogo: React.FC<BrandLogoProps> = ({
  className = 'w-10 h-10',
  alt = 'BHABY HEALTH CONNECT',
}) => (
  <img
    src={`${process.env.PUBLIC_URL}/logo.png`}
    alt={alt}
    className={`${className} object-contain`}
    draggable={false}
  />
);

export default BrandLogo;
